import { connect } from 'react-redux';
import LaporanPengunjungDetail from '../../../views/Library/LaporanPengunjung/LaporanPengunjungDetail.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(LaporanPengunjungDetail);
